const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateContact = (values) => {
  const errors = {};
  const email = String(values.email || '').trim();
  const message = String(values.message || '').trim();

  if (!EMAIL_PATTERN.test(email) || email.length > 254) {
    errors.email = 'Geçerli bir e-posta adresi girin.';
  }
  if (!values.subject) {
    errors.subject = 'Bir konu seçin.';
  }
  if (message.length < 10) {
    errors.message = 'Mesaj en az 10 karakter olmalıdır.';
  }
  if (!values.turnstileToken) {
    errors.turnstileToken = 'Güvenlik doğrulamasını tamamlayın.';
  }
  return errors;
};

export const validateDeletionEmail = (values) => {
  const errors = {};
  const email = String(values.email || '').trim();
  if (!EMAIL_PATTERN.test(email) || email.length > 254) {
    errors.email = 'Geçerli bir e-posta adresi girin.';
  }
  if (!values.turnstileToken) {
    errors.turnstileToken = 'Güvenlik doğrulamasını tamamlayın.';
  }
  return errors;
};

export const validateDeletionRequest = (values) => {
  const errors = {};
  if (!/^\d{6}$/.test(String(values.code || ''))) {
    errors.code = '6 haneli doğrulama kodunu girin.';
  }
  if (!values.deletionRequestType) {
    errors.deletionRequestType = 'Bir talep türü seçin.';
  }
  if (!values.confirmationsAccepted) {
    errors.confirmationsAccepted = 'Silme işlemi onaylarını kabul edin.';
  }
  if (!values.subscriptionCancellationAcknowledged) {
    errors.subscriptionCancellationAcknowledged =
      'Aktif abonelik varsa Google Play üzerinden iptal sorumluluğunu onaylayın.';
  }
  if (!values.turnstileToken) {
    errors.turnstileToken = 'Güvenlik doğrulamasını tamamlayın.';
  }
  return errors;
};
